<div class="p-5 flex flex-col items-center justify-center gap-3">
  <div class="loader"></div>
  <p class="text-lms-text-1">{{ message }}</p>
</div>
